module.exports = __webpack_public_path__ + "static/media/gAbout.991bb3b4.png";